import { UseCase } from '@core/referential/use-case.enum'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import PendingComponent from '@/components/pending-component'
import { Permission } from '@/lib/permissions'
import { isUseCase } from '@/lib/utils'

export const SearchSchema = z.object({
  tab: z.union([z.literal('comfort'), z.literal('dju'), z.literal('referenceYear')]).default('comfort'),
})

export type Search = z.infer<typeof SearchSchema>

export const Route = createFileRoute('/_dashboard/company/settings/')({
  validateSearch: SearchSchema,
  beforeLoad({ context }) {
    if ((!isUseCase(UseCase.ENERGY) && !isUseCase(UseCase.CONSUMPTIONS)) || !context.user?.hasPermission(Permission.COMPANY_SETTINGS)) {
      throw redirect({
        to: '/403',
      })
    }
  },
  pendingComponent: PendingComponent,
})
